module.exports = __webpack_public_path__ + "img/limit-exempt-bg_0901.b21ed8f6.jpg";